import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CustomSwitchComponent, SwitchText } from "../../../../../shared/components/custom-switch/custom-switch.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CapitalizePipe } from '../../../../../core/pipes/capitalize.pipe';
import { MediaQueryModule } from '../../../../../shared/directives/media-querys/media-query.module';
import { UserDetail, ActionContext } from '../../../../../core/models/user.models';

export interface ActionHeaderMenu {
  id: SubMenuTypes,
  value: string,
  isSelected: boolean
}
export enum SubMenuTypes {
  PROFILE_DATA = "profileData",
  CONTACT_INFORMATION = "contactInformation",
  FISCAL_DATA = "fiscalData",
  ROLES_AND_PERMISSIONS = "rolesPermissions"
}

@Component({
  selector: 'app-actions-header',
  standalone: true,
  imports: [CommonModule, CustomSwitchComponent, FontAwesomeModule, TranslateModule, CapitalizePipe,
    MediaQueryModule
  ],
  templateUrl: './actions-header.component.html',
  styleUrl: './actions-header.component.scss'
})
export class ActionsHeaderComponent {
  @Input() mode!: "create" | "update";
  @Input() context!: ActionContext;
  @Input() user!: UserDetail;
  @Input() subMenuSelected!: SubMenuTypes;
  @Input() isActive: boolean = true;
  @Input() isAdmin: boolean = false;
  
  @Output() closeEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() subMenuSelectedEmitter: EventEmitter<SubMenuTypes> = new EventEmitter();
  @Output() currentCheckEmitter: EventEmitter<boolean> = new EventEmitter();

  subMenus: ActionHeaderMenu[] = [];
  subMenusEnum = SubMenuTypes;
  actionContextEnum = ActionContext;
  
  constructor(private translateService: TranslateService) {}

  switchText: SwitchText = {
    orientation: 'left',
    activeValue: this.translateService.instant("configuration-page.action-dialog.user-active"),
    inactiveValue: this.translateService.instant("configuration-page.action-dialog.user-inactive"),
  }

  ngOnInit() {
    this.subMenus = [
      {
        id: SubMenuTypes.PROFILE_DATA,
        value: this.translateService.instant("configuration-page.action-dialog.profile-data"),
        isSelected: true
      },
      {
        id: SubMenuTypes.CONTACT_INFORMATION,
        value: this.translateService.instant("configuration-page.action-dialog.contact-information"),
        isSelected: false
      },
      {
        id: SubMenuTypes.FISCAL_DATA,
        value: this.translateService.instant("configuration-page.action-dialog.fiscal-data"),
        isSelected: false
      },
      {
        id: SubMenuTypes.ROLES_AND_PERMISSIONS,
        value: this.translateService.instant("configuration-page.action-dialog.roles&permissions"),
        isSelected: false
      },
    ]

    if(this.subMenuSelected) {
      this.toggleSubMenu(this.subMenuSelected);
    }
  }

  toggleSubMenu(subMenuId: SubMenuTypes) {
    if((this.user || (subMenuId === this.subMenusEnum.PROFILE_DATA))  && 
     !(subMenuId === this.subMenusEnum.ROLES_AND_PERMISSIONS && this.isAdmin)) {
      this.subMenus.forEach((subMenu: ActionHeaderMenu) => 
        subMenu.isSelected = subMenu.id === subMenuId
      );
  
      this.subMenuSelectedEmitter.emit(subMenuId);
    }

  }

  emitCheckState(isActive: boolean) {
    this.currentCheckEmitter.emit(isActive);
  }
  
  close() {
    this.closeEmitter.emit(true);
  }
}
